import HeroBg from '../../../assets/background/HeroBg';
import {
    TotalProtocolFeesIcon,
    TotalTradingVolumeIcon,
    TotalValueLockedIcon,
} from '../../../assets/icons';
import Button from '../../../components/Button';
import { BasePath } from '../../../config/constants';
import { formatAmountWithSuffix } from '../../../helpers';
import usePlatformStats from '../../../hooks/analytics/usePlatformStats';
import HeroCard from './HeroCard';

const Hero = () => {
    const { platformStats } = usePlatformStats();

    return (
        <section id='hero'>
            <div className='container'>
                <HeroBg />
                <div className='content'>
                    <h1>
                        UNLIMITED
                        <span>Synthetic Leverage</span>
                    </h1>
                    <p>
                        Trade your favorite cryptocurrencies synthetically with zero price
                        impact, minimal slippage, and up to 100x leverage.
                    </p>
                    <div className='buttons-container'>
                        <Button
                            variant='secondary'
                            externalLink='https://docs.unlimited.trade/'
                        >
                            Docs
                        </Button>
                        <Button internalLink={`${BasePath.TRADE}/BTCUSD`}>
                            Start Trading
                        </Button>
                    </div>
                </div>
                <div className='hero-info'>
                    <HeroCard
                        icon={<TotalValueLockedIcon />}
                        title='Total Value Locked'
                        value={
                            platformStats
                                ? `$ ${formatAmountWithSuffix(
                                      platformStats.totalValueLocked.toString() || 0,
                                      {
                                          maxDecimals: 0,
                                          minValue: 9_999_999_999.99,
                                          currency: '',
                                      }
                                  )}`
                                : '-'
                        }
                    />
                    <HeroCard
                        icon={<TotalTradingVolumeIcon />}
                        title='Total Trading Volume'
                        value={
                            platformStats
                                ? `$ ${formatAmountWithSuffix(
                                      platformStats.totalTradingVolume?.toString() || 0,
                                      {
                                          maxDecimals: 0,
                                          minValue: 9_999_999_999.99,
                                          currency: '',
                                      }
                                  )}`
                                : '-'
                        }
                    />
                    <HeroCard
                        icon={<TotalProtocolFeesIcon />}
                        title='Total Protocol Fees'
                        value={
                            platformStats
                                ? `$ ${formatAmountWithSuffix(
                                      platformStats.totalProtocolFees.toString() || 0,
                                      {
                                          maxDecimals: 0,
                                          minValue: 9_999_999_999.99,
                                          currency: '',
                                      }
                                  )}`
                                : '-'
                        }
                    />
                </div>
            </div>
        </section>
    );
};

export default Hero;
